import ProveedorCreate from './ProveedorCreate'
export {ProveedorCreate}
export default ProveedorCreate
